import moment from "moment";
const gmtOffsetMinutes = -new Date().getTimezoneOffset();
const TimeBlock: React.FC<{ date?: string | Date | null, cssClass?: string }> = ({ date, cssClass }) => {
    if (!date) return null;
    const m = moment(date).utcOffset(gmtOffsetMinutes);
    return (
        <div className={cssClass}>
            {m.format('HH:mm')}
            {!m.isSame(moment(), 'day') && (
                <div className="text-blue-800 block">{m.format('DD MMM')}</div>
            )}
        </div>
    );
};

export default TimeBlock;
